export default "__VITE_ASSET__6d402563__"